import React, { useEffect, useRef, useState } from 'react';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import PrimeReact from 'primereact/api';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Tooltip } from 'primereact/tooltip';

import { useHistory } from 'react-router-dom';
import { useToast } from '../../../hooks/toast';
import { Container } from '../styles';
import api from '../../../services/api';

 interface IRoomProperties {
  id: number | null;
  room_description: string;
}

const MeetingRoom: React.FC = () => {
  // active ripple effect
  PrimeReact.ripple = true;

  const emptyRoom = {
    id: null,
    room_description: '',
  };

  const [rooms, setRooms] = useState<IRoomProperties[]>([]);
  const [room, setRoom] = useState(emptyRoom);
  const [deleteRoom, setDeleteInterventionDialog] = useState(false);
  const [selectedRooms, setSelectedRooms] = useState<IRoomProperties[]>([]);

  // para tabela
  const [globalFilter, setGlobalFilter] = useState('');
  const dt = useRef(null);
  const { addToast } = useToast();
  const history = useHistory();

  useEffect(() => {
    (async () => {
      const response = await api.get('/schedules/meetings/rooms/show/all');
      setRooms(response.data);
    })();
  }, []);

  const columns = [
    { field: 'id', header: 'Código', sortable: true },
    { field: 'room_description', header: 'Descrição', sortable: true },
  ];

  const dynamicColumns = columns.map((col) => (
    <Column
      key={col.field}
      field={col.field}
      header={col.header}
      sortable
    />
  ));

  const handleCreate = () => {
    history.push('/schedule/meeting/room/create');
  };

  const hidedeleteRoom = () => {
    setDeleteInterventionDialog(false);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const editIntervention = (rowData:any) => {
    history.push(`/schedule/meeting/room/edit/${rowData.id}`);
  };

  // eslint-disable-next-line @typescript-eslint/no-shadow
  const confirmDeleteIntervention = (room: React.SetStateAction<{
    id: null; room_description: string;
  }>) => {
    setRoom(room);
    setDeleteInterventionDialog(true);
  };

  const deleteGroup = () => {
    api.delete(`/schedules/meetings/rooms/delete/${room.id}`);

    setDeleteInterventionDialog(false);

    const updatedRecords = rooms
      .filter((val) => val.id !== room.id);
    setRooms(updatedRecords);

    addToast({
      type: 'success',
      title: 'Cadastro excluído!',
      description:
        'O cadastro selecionado foi excluído com sucesso!',
    });
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const actionBodyTemplate = (rowData: any) => (
    <>
      {rowData.id > 0 ? (
        <>
          <Button
            type="button"
            icon="pi pi-pencil"
            tooltip="Alterar cadastro"
            tooltipOptions={{ position: 'left' }}
            className="p-button-rounded p-button-text p-button-plain p-mr-2"
            onClick={() => { editIntervention(rowData); }}
          />
          <Button
            type="button"
            icon="pi pi-trash"
            tooltip="Excluir cadastro"
            tooltipOptions={{ className: 'red-tooltip', position: 'left' }}
            className="p-button-rounded p-button-text p-button-plain"
            onClick={() => { confirmDeleteIntervention(rowData); }}
          />
        </>
      ) : null}
    </>
  );

  const header = (
    <div className="flex align-items-center export-buttons">
      <Button
        type="button"
        label="Novo"
        icon="pi pi-plus"
        className="p-button-primary p-mr-2"
        onClick={handleCreate}
        tooltip="Novo cadastro"
        tooltipOptions={{ position: 'right' }}
      />
      <span className="p-input-icon-left p-ml-auto">
        <i className="pi pi-search" />
        <InputText type="search" value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Pesquisar na tabela" />
      </span>
    </div>
  );

  const paginatorLeft = <Button type="button" icon="pi pi-refresh" className="p-button-text" />;
  const paginatorRight = <Button type="button" icon="pi pi-cloud" className="p-button-text" />;

  const deleteRoomFooter = (
    <>
      <Button type="button" label="Não" icon="pi pi-times" className="p-button-text" onClick={hidedeleteRoom} />
      <Button type="button" label="Sim" icon="pi pi-check" className="p-button-text" onClick={deleteGroup} />
    </>
  );

  return (
    <Container>
      <header>
        <div>
          <h1>Salas de reunião</h1>
        </div>
      </header>

      <div className="datatable-responsive">

        <div className="card">

          <Tooltip target=".export-buttons>button" position="bottom" />

          <DataTable
            tableClassName="table-rooms table"
            id="table-rooms"
            ref={dt}
            value={rooms}
            editMode="row"
            dataKey="id"
            header={header}
            stripedRows
            className="p-datatable-sm"
            paginator
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords}"
            rows={50}
            rowsPerPageOptions={[10, 20, 50]}
            paginatorLeft={paginatorLeft}
            paginatorRight={paginatorRight}
            globalFilter={globalFilter}
            emptyMessage="Nenhum registro encontrado."
            selectionMode="multiple"
            selection={selectedRooms}
            onSelectionChange={(e) => {
              const selRooms = e.value as IRoomProperties[];
              setSelectedRooms(selRooms);
            }}
            onRowDoubleClick={(e) => editIntervention(e.data)}
          >
            {dynamicColumns}
            <Column body={actionBodyTemplate} align="right" style={{ width: '120px' }} />
          </DataTable>

        </div>

        <div>
          <Dialog visible={deleteRoom} style={{ width: '450px' }} header="Confirmação" modal footer={deleteRoomFooter} onHide={hidedeleteRoom}>
            <div className="confirmation-content">
              <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
              {room && (
              <span>
                Você tem certeza que deseja excluir
                <br />
                <br />
                <b>{room.room_description}</b>
                ?
              </span>
              )}
            </div>
          </Dialog>
        </div>

      </div>

    </Container>

  );
};

export default MeetingRoom;
